import { Autocomplete } from 'components/Autocomplete'
import { useSetorService } from 'hooks/useSetorService'
import { useCallback, useEffect } from 'react'
import { useSelector } from 'react-redux'

export const SelectSetor = (props) => {
  const setorService = useSetorService()
  const setores = useSelector((state) => state.options.setores)
  const { setoresExternos, setSetoresExternos, setProcessando, label } = props

  const fetchSetores = useCallback(() => {
    setorService.listarSetoresGlobal(setProcessando)
  }, [])

  useEffect(() => {
    fetchSetores()
  }, [fetchSetores])

  const getSetorLabel = option => `${option.nome} / ${option.divisao.sigla} / ${option.divisao.regional.nome} / ${option.divisao.regional.orgao.sigla}`.toUpperCase()

  return (
    <Autocomplete
      value={setoresExternos}
      multiple
      name="setor"
      options={setores || []}
      onChange={(event, newValue) => {
        setSetoresExternos(newValue)
      }}
      getOptionLabel={getSetorLabel}
      getTagLabel={(option) => option.sigla}
      getTagTooltip={getSetorLabel}
      label={label || 'Setores'}
    />
  )
}
